import { useContext } from 'react';
import ConnectionChangeContext from './ConnectionChangeContext';
import { ConnectionChangeContextIsNotInitialized } from './errors';
const useConnectionChange = () => {
    const context = useContext(ConnectionChangeContext);
    if (!context) {
        throw new ConnectionChangeContextIsNotInitialized();
    }
    return context;
};
export default useConnectionChange;
